import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM } from '@surfline/web-common';

import GoogleDFP from 'components/GoogleDFP';
import loadAdConfig from 'utils/adConfig';
import writeDebugLog from 'utils/writeDebugLog';

export interface HeaderAdProps {
  isVisible?: boolean;
  adConfigName?: string;
  adTarget?: any;
  entitlements?: any[] | undefined;
  styles?: {};
  userDetails?: any;
  adKey?: string;
}

export const HeaderAd: React.FC<HeaderAdProps> = ({
  isVisible = true,
  adConfigName = '',
  adTarget = [],
  entitlements = [],
  styles = {},
  userDetails = false,
  adKey = '',
}) => {
  const [headerAdElement, setHeaderAdElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    writeDebugLog(`HeaderAd - useEffect=${adConfigName} isVisible=${isVisible}`);

    if (canUseDOM) {
      const element = document?.getElementById('sl-header-ad');
      if (element && Object.keys(styles).length > 0) {
        Object.assign(element.style, styles);
      }
      setHeaderAdElement(element);
    }
  }, [adConfigName, styles]);

  // Don't render anything if we don't have the target element or if not visible
  if (!headerAdElement || !isVisible) {
    return null;
  }

  // Use React portal to render into the header ad element
  return createPortal(
    <div key={adKey}>
      <GoogleDFP adConfig={loadAdConfig(adConfigName, adTarget, entitlements, userDetails, null)} />
    </div>,
    headerAdElement,
  );
};

export default HeaderAd;
